export default "__VITE_ASSET__8e81aee8__"